import { render, staticRenderFns } from "./relatorioContratosIndicadores.vue?vue&type=template&id=5f21dffd"
import script from "./relatorioContratosIndicadores.vue?vue&type=script&lang=js"
export * from "./relatorioContratosIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports